import { useLazyQuery } from '@apollo/client'
import { Events, EventsVariables } from '../../types'
import { EVENTS } from './operations'

interface Props {
  onCompleted?: () => void
}

export const useEventsLazy = ({ onCompleted }: Props) =>
  useLazyQuery<Events, EventsVariables>(EVENTS, {
    onCompleted,
  })
